export function appendMissingZero(minutesString) {
    if (minutesString && minutesString.length === 1) {
        return minutesString + "0";
    }

    return minutesString;
}
